import { DtoDatafrontElement } from '../DtoDatafrontElement';
import { Input } from '@angular/core';

export class DatafrontElementBase {
  @Input() element = new DtoDatafrontElement();
  showActionsControl = false;
}
